import api from '@pray/shared/utils/api';

export async function getElevenLabsModels() {
  const url = `/web/studio/elevenlabs-models`;
  const response = await api.executeGetRequest(url);
  return response.data;
}
